var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
/* Personal Loan Rates Modal */
__p+='\n';
  let { url } = options; 
__p+='\n<div class="modal fade modal-mobile-fullscreen  modal-personal-loan" id="personal-loan" tabindex="-1" role="dialog" aria-labelledby="mortgageModalLabel" aria-hidden="true">\n  <div class="modal-dialog modal-lg">\n    <div class="modal-content">\n      <div class="modal-header">\n        <button type="button" class="close" data-dismiss="modal" aria-label="Close">\n          <span class="modal-x-icon hidden-xs hidden-xxs" aria-hidden="true">×</span>\n          <span class="hidden-lg hidden-md hidden-sm" aria-hidden="true"><i class="ra ra-angle-left"></i></span>\n        </button>\n        <h2 class="modal-title"> Personal Loan Rates</h2>\n      </div>\n      <div class="modal-body">\n        <iframe src="'+
((__t=(url))==null?'':__t)+
'" width="100%" scrolling="no" frameborder="0"></iframe>\n      </div>\n    </div>\n  </div>\n</div>\n<script type="text/javascript">\n  iFrameResize({ log: false, checkOrigin: false });\n</script>\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/mortgage/modal/index.jst.ejs